import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../AdminDash/components/ui/tabs";
import { GeneratePagePDFProductAlternative } from "../../../components/GeneratePDF/GeneratePDFProduct";
import ProductImageLabel from "./components/lca/ProductImageLabel";
import ProductHeader from "./components/lca/ProductHeader";
import RawMaterialComponents from "./ProdRawMaterials";
import TransportA2Components from "./ProdTransportA2";
import ProdManufacturingComponents from "./ProdManufacturing";
import ProdCustomManufacturingComponents from "./ProdCustomManufacturing";
import ProdEnergyComponents from "./ProdEnergy";
import ProdSurplusResources from "./ProdSurplusResource";
import Losses35Components from "./ProdLosses35";
import Transportation36Components from "./ProdTransportation36";
import ProdInstallationConstruction37Components from "./ProdInstallationConstruction37";
import Transportation38Components from "./ProdTransportation38";
import ServiceLife39Components from "./ProdServiceLife39";
import ProdUseStage41Components from "./ProdUseStage41";
import ProdMaintenance41_2Components from "./ProdMaintenance41_2";
import ProdRepair41_3Components from "./ProdRepair41_3";
import ProdReplacement41_4Components from "./ProdReplacement41_4";
import ProdRefurbishment41_5Components from "./ProdRefurbishment41_5";
import ProdEndOfLife42Components from "./ProdEndOfLife42";
import ProdTransportationEoL43Components from "./ProdTransportationEoL43";
import ProdWasteProcessing44Components from "./ProdWasteProcessing44";
import ProdDisposal45Components from "./ProdDisposal45";
import ProdBeyondProductLifeCycle46Components from "./ProdBeyondProductLifeCycle46";
import ProdMassBalance47Components from "./ProdMassBalance47";
import ProdLCAResults48Components from "./ProdLCAResults48";
import LCAPhaseSelection from "./components/lca/LCAPhaseSelection";
import OpenCircSyncButton from "./components/lca/OpenCircSyncButton";
import LovablePhaseSection from "./components/LovablePhaseSection";
import {
  LovableFlowSeparator,
  LovableGeneratePdfButton,
} from "./components/LovableFlowControls";
import { LOVABLE_FLOW_SEPARATOR } from "./components/lovableFlowSeparators";
import { clearLcaProductDropdownCache } from "../../../apis/lcaDropdownCache";
import { prefetchLCADropdowns } from "./lcaDropdownPrefetch";
import { mapDppFromProduct } from "../../../apis/Product/ProductEPDApi";
import "./ProductDetailViewNew.css";

export const ProductDetailViewNew = ({ showCategory, setShowCategory }) => {
  const { productId } = useParams();
  const [productData, setProductData] = useState({
    productName: "",
    productNumber: "",
    manufacturingCountry: "Turkey",
    lifetime: "300",
    lifetimeUnit: "use",
    salesPercentage: "",
    weightExcl: "750",
    weightReading: "750",
    weightIncl: "750",
    waste: "0",
    wasteReading: "0",
    totalWeight: "0",
    totalReading: "0",
    soldChecked: false,
    soldAmount: "",
    leasedChecked: false,
    leasedAmount: "",
    takebackChecked: false,
    takebackAmount: "",
    fuAmount: "1",
    fuUnit: "pcs",
    functionalUnit: "",
    certifications: [{ certificate: "", verified: "no", date: "", organization: "", uid: "" }],
    ccsClassification: "",
    gtinEan: "",
    bastaNumber: "",
    otherIds: "",
    createdModified: "",
    sector: "",
  });

  const [productName, setProductName] = useState("");
  const [productNumber, setProductNumber] = useState("");
  const [lockStatus, setLockStatus] = useState("unlocked"); // from backend: unlocked | calc_ended | epd_locked
  const [lockRefreshTrigger, setLockRefreshTrigger] = useState(0); // increment to refetch product (e.g. after EPD submit/revision)
  const [dppData, setDppData] = useState(null);
  const [activeTab, setActiveTab] = useState("environment");
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [pdfProgress, setPdfProgress] = useState("");

  useEffect(() => {
    if (!productId) return;
    prefetchLCADropdowns(productId);
    return () => {
      clearLcaProductDropdownCache(productId);
    };
  }, [productId]);

  const handleEpdLockChange = (productUpdate) => {
    if (productUpdate && typeof productUpdate === "object") {
      if (productUpdate.lca_lock_status) {
        setLockStatus(productUpdate.lca_lock_status);
      }
      const mapped = mapDppFromProduct(productUpdate);
      if (productUpdate.lca_lock_status === "epd_locked") {
        if (mapped) setDppData(mapped);
      } else if (productUpdate.lca_lock_status) {
        // Don't show a published DPP panel unless product is actually EPD-locked
        setDppData(null);
      }
    }
    setLockRefreshTrigger((t) => t + 1);
  };

  const handleDppUpdate = (updated) => {
    if (updated) setDppData(updated);
    setLockRefreshTrigger((t) => t + 1);
  };

  const handleGeneratePDF = async () => {
    setIsGeneratingPDF(true);
    setPdfProgress("Initializing PDF generation...");
    try {
      const result = await GeneratePagePDFProductAlternative({
        filename: `product-lca-${productId}-${new Date().toISOString().split("T")[0]}.pdf`,
        onProgress: setPdfProgress,
        quality: 0.8,
        format: "a4",
      });
      if (result.success) {
        setPdfProgress(`PDF generated successfully! (${result.pageCount} pages)`);
        setTimeout(() => { setPdfProgress(""); setIsGeneratingPDF(false); }, 3000);
      } else {
        throw new Error(result.error);
      }
    } catch (error) {
      setPdfProgress("Failed to generate PDF. Please try refreshing and trying again.");
      setTimeout(() => { setPdfProgress(""); setIsGeneratingPDF(false); }, 5000);
    }
  };

  return (
    <Container fluid className="product-detail-view-new">
      <div className="product-detail-view-new-content">
        {/* Left Sidebar - Product Image and Label */}
        <div className="product-detail-view-new-sidebar">
          <ProductImageLabel
            productName={productName}
            setProductName={setProductName}
            productNumber={productNumber}
            setProductNumber={setProductNumber}
            productId={productId}
            onEpdLockChange={handleEpdLockChange}
            lockStatus={lockStatus}
            lockRefreshTrigger={lockRefreshTrigger}
            dppData={lockStatus === "epd_locked" ? dppData : null}
            onDppUpdate={handleDppUpdate}
          />
        </div>

        {/* Main Content Area */}
        <div className="product-detail-view-new-main">
          {/* OpenCirc Sync Button - Above main content */}
          <div className="opencirc-sync-section">
            <OpenCircSyncButton productId={productId} lockStatus={lockStatus} sector={productData.sector} />
          </div>

          {/* Product Header - Above Flow 31 */}
          <div className="product-detail-view-new-header-section">
            <ProductHeader
              data={productData}
              setData={setProductData}
              productId={productId}
              onLockStatusLoad={setLockStatus}
              setDppData={setDppData}
              lockRefreshTrigger={lockRefreshTrigger}
              lcaLockStatus={lockStatus}
              onEpdApprovalSaved={() => setLockRefreshTrigger((t) => t + 1)}
            />
          </div>

        
        </div>
      </div>
      {/* LCA Phase Selection – System Boundary */}
      <div className="product-detail-view-new-phase-selection-section" style={{ marginTop: "20px" }}>
        <LCAPhaseSelection productId={productId} />
      </div>

      {/* E / S / G / Alignment Tabs – below system boundary */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="product-detail-view-new-esg-tabs" style={{ marginTop: "20px" }}>
        <TabsList style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
          <TabsTrigger value="environment">E – Environment</TabsTrigger>
          <TabsTrigger value="social">S – Social</TabsTrigger>
          <TabsTrigger value="governance">G – Governance</TabsTrigger>
          <TabsTrigger value="alignment">Alignment</TabsTrigger>
        </TabsList>

        <TabsContent value="environment">
          {/* Flow 31 and below */}
          <div className="azilis-detail-flows product-detail-view-new-flows">
        <LovablePhaseSection className="raw-material-relative" id="a1">
          <RawMaterialComponents
            productId={productId}
            showCategory={showCategory}
            setShowCategory={setShowCategory}
          />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.RAW_MATERIALS}
            label="Between raw materials and transport"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="transport-a2-relative" id="a2">
          <TransportA2Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.TRANSPORT}
            label="Between transport and manufacturing"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="prod-manufacturing-relative" id="a3">
          <ProdManufacturingComponents productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.MANUFACTURING}
            label="Between manufacturing and custom manufacturing"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="prod-custom-manufacturing-relative" id="a34">
          <ProdCustomManufacturingComponents productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.SETTINGS}
            label="Between custom manufacturing and losses"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="losses-35-relative" id="a35">
          <Losses35Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.TRANSPORT}
            label="Between losses and transportation"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="transportation-36-relative" id="a36">
          <Transportation36Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.INSTALLATION}
            label="Between transportation and installation"
          />
        </LovablePhaseSection>

        <LovablePhaseSection
          className="prod-installation-construction-37-relative"
          id="a37"
        >
          <ProdInstallationConstruction37Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.TRANSPORT}
            label="Between installation and transportation"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="transportation-38-relative" id="a38">
          <Transportation38Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.SERVICE_LIFE}
            label="Between transportation and service life"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="service-life-39-relative" id="a39">
          <ServiceLife39Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.USE}
            label="Between service life and use stage"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="use-stage-41-relative" id="a41">
          <ProdUseStage41Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.MAINTENANCE}
            size="lg"
            label="Between use and maintenance"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="maintenance-41-2-relative" id="a41_2">
          <ProdMaintenance41_2Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.REPAIR}
            label="Between maintenance and repair"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="repair-41-3-relative" id="a41_3">
          <ProdRepair41_3Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.REPLACEMENT}
            label="Between repair and replacement"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="replacement-41-4-relative" id="a41_4">
          <ProdReplacement41_4Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.REFURBISHMENT}
            label="Between replacement and refurbishment"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="refurbishment-41-5-relative" id="a41_5">
          <ProdRefurbishment41_5Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.END_OF_LIFE}
            size="lg"
            label="Between refurbishment and end of life"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="end-of-life-42-relative" id="c1">
          <ProdEndOfLife42Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.TRANSPORT}
            label="Between end of life and transportation EoL"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="transportation-eol-43-relative" id="c1_transport">
          <ProdTransportationEoL43Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.SETTINGS}
            label="Between transportation EoL and waste processing"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="waste-processing-44-relative" id="c1_waste">
          <ProdWasteProcessing44Components productId={productId} />
          <LovableFlowSeparator
            type={LOVABLE_FLOW_SEPARATOR.DISPOSAL}
            label="Between waste processing and disposal"
          />
        </LovablePhaseSection>

        <LovablePhaseSection className="disposal-45-relative" id="c1_disposal">
          <ProdDisposal45Components productId={productId} />
        </LovablePhaseSection>

        <LovablePhaseSection
          className="beyond-product-life-cycle-46-relative"
          id="c1_beyond"
        >
          <ProdBeyondProductLifeCycle46Components productId={productId} />
        </LovablePhaseSection>

        <LovablePhaseSection className="mass-balance-47-relative" id="mass_balance">
          <ProdMassBalance47Components productId={productId} />
        </LovablePhaseSection>

        <LovablePhaseSection className="lca-results-48-relative" id="lca_results">
          <ProdLCAResults48Components productId={productId} />
        </LovablePhaseSection>
          </div>
        </TabsContent>

        <TabsContent value="social">
          <div style={{ padding: "40px", textAlign: "center", background: "rgba(32,54,105,0.03)", borderRadius: "16px", border: "1px dashed rgba(0,0,0,0.15)", marginTop: "16px" }}>
            <p style={{ fontSize: "14px", color: "#94a3b8", margin: 0 }}>
              Social indicators – coming soon.
            </p>
          </div>
        </TabsContent>

        <TabsContent value="governance">
          <div style={{ padding: "40px", textAlign: "center", background: "rgba(32,54,105,0.03)", borderRadius: "16px", border: "1px dashed rgba(0,0,0,0.15)", marginTop: "16px" }}>
            <p style={{ fontSize: "14px", color: "#94a3b8", margin: 0 }}>
              Governance indicators – coming soon.
            </p>
          </div>
        </TabsContent>

        <TabsContent value="alignment">
          <div style={{ padding: "40px", textAlign: "center", background: "rgba(32,54,105,0.03)", borderRadius: "16px", border: "1px dashed rgba(0,0,0,0.15)", marginTop: "16px" }}>
            <p style={{ fontSize: "14px", color: "#94a3b8", margin: 0 }}>
              Alignment analysis – coming soon.
            </p>
          </div>
        </TabsContent>
      </Tabs>

      <div className="lovable-page-footer">
        <LovableGeneratePdfButton
          onClick={handleGeneratePDF}
          isGenerating={isGeneratingPDF}
        />
        {pdfProgress && (
          <p
            className={[
              "lovable-page-footer__status",
              pdfProgress.includes("Failed")
                ? "lovable-page-footer__status--error"
                : pdfProgress.includes("successfully")
                  ? "lovable-page-footer__status--success"
                  : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {pdfProgress}
          </p>
        )}
      </div>
    </Container>
  );
};

export default ProductDetailViewNew;
